import { useState } from 'react';

const SHOULD_INSERT_BELOW_STORAGE_KEY = 'shouldInsertChartBelow';

/** Whether copies go below their source rather than at the bottom, remembered across sessions */
export const useShouldInsertBelow = () => {
    const [shouldInsertBelow, setShouldInsertBelow] = useState<boolean>(
        () => localStorage.getItem(SHOULD_INSERT_BELOW_STORAGE_KEY) === 'true',
    );

    const toggleShouldInsertBelow = () => {
        const newValue = !shouldInsertBelow;
        localStorage.setItem(
            SHOULD_INSERT_BELOW_STORAGE_KEY,
            newValue.toString(),
        );
        setShouldInsertBelow(newValue);
    };

    return { shouldInsertBelow, toggleShouldInsertBelow };
};
